export default __webpack_public_path__ + "static/media/Zahl-1.09f0e024.png";